import { createContext } from 'react';

/**
 * True inside a `ListingCarousel`. `ListingCard` reads it to render as a navigation-only card: a
 * rail is for browsing, so its cards show one static photo and no save, share or contact
 * controls, whatever their caller passes.
 */
export const InListingCarouselContext = createContext(false);
